import { render, staticRenderFns } from "./subsidy-add-or-update.vue?vue&type=template&id=4c3b65e0&"
import script from "./subsidy-add-or-update.vue?vue&type=script&lang=js&"
export * from "./subsidy-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports